import React, { useEffect, useState, useMemo } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Eye } from "lucide-react";
import DetailsView from "./DetailsView";
import Loader from "../../../../Utils/Loader";
import "react-datepicker/dist/react-datepicker.css";
import {
  getSubAdminPositions,
  updateTargetAndStoploss,
  getUserName,
} from "../../../../Service/admin.service";
import { fDateTimeSuffix } from "../../../../Utils/Date_formet";
import "react-datepicker/dist/react-datepicker.css";
import { TRADE_EXECUTE } from "../../../../Service/user.service";
import toast from "react-hot-toast";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable1";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { SET_THEME_DETAILS } from "../../../../Service/auth.service";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import { useDispatch } from "react-redux";
import { usePrices } from "../../../../context/PriceContext"; // ✅ Import करें

const Tradinghistory = (token) => {
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));

  const prices = usePrices(); // ✅ Context से prices लें
  const dispatch = useDispatch();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [strategy, setStrategy] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [rowData, setRowData] = useState("");
  const [tradeHistoryData, setTradeHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [editableRows, setEditableRows] = useState({});
  const [tradeUpdates, setTradeUpdates] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [quantityM, setQuantity] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [btnstatus, setBtnstatus] = useState("");
  const [orderType, setOrderType] = useState("");
  const [allStrategy, setAllStrategy] = useState([]);
  const [entryType, setEntryType] = useState("");
  const [SelectedUserName, setSelectedUserName] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [AllUsername, setAllUSerName] = useState([]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newLimit, page) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    getCompanydata();
    GetAllStrategy();
    GetUSerName();
  }, []);

  const GetUSerName = async () => {
    const GetUserName = await getUserName({});
    if (GetUserName.status) {
      setAllUSerName(GetUserName.data);
    } else {
      setAllUSerName([]);
    }
  };

  const GetAllStrategy = async () => {
    try {
      dispatch(
        Get_All_Service_for_Client({
          req: {},
          token: user_details.token,
        })
      )
        .unwrap()
        .then((response) => {
          if (response.status) {
            setAllStrategy(response.data);
          }
        });
    } catch (error) { }
  };

  useEffect(() => {
    fetchTradeHistory();
  }, [
    fromDate,
    toDate,
    refresh,
    strategy,
    orderType,
    btnstatus,
    entryType,
    limit,
    currentPage,
    SelectedUserName,
  ]);

  // Calculate P&L function (reusable)
  const calculatePnL = (trade, livePrice) => {
    const entryPrice = parseFloat(trade.entryPrice);
    const exitPrice = parseFloat(trade.exitPrice);
    const qty = quantityM && quantityM > 0 ? quantityM : trade.quantity;
    const isOpen = trade.orderid?.length === 1;

    if (!entryPrice || qty <= 0) return 0;

    let pnl = 0;

    if (isOpen && livePrice) {
      pnl =
        trade.side === "BUY"
          ? (livePrice - entryPrice) * qty
          : (entryPrice - livePrice) * qty;
    } else if (!isOpen && exitPrice) {
      pnl =
        trade.side === "BUY"
          ? (exitPrice - entryPrice) * qty
          : (entryPrice - exitPrice) * qty;
    }

    return pnl;
  };

  // Memoized filtered data and P&L calculations
  const { filteredTradeData, totalPnl, unrealizedPnl } = useMemo(() => {
    let filtered = tradeHistoryData.filter((trade) => {
      const matchStrategy = strategy ? trade.strategy === strategy : true;
      const matchSearch =
        trade.symbol
          ?.toLowerCase()
          .includes(debouncedSearchTerm.toLowerCase()) ||
        trade.strategy
          ?.toLowerCase()
          .includes(debouncedSearchTerm.toLowerCase());
      return matchStrategy && matchSearch;
    });

    let calculatedTotalPnl = 0;
    let calculatedUnrealizedPnl = 0;

    filtered.forEach((trade) => {
      const livePrice = prices?.[trade?.symbol]?.spot_price; // ✅ Context से price
      const pnl = calculatePnL(trade, livePrice);

      if (trade.orderid?.length === 2) {
        calculatedTotalPnl += pnl;
      } else if (trade.orderid?.length === 1) {
        calculatedUnrealizedPnl += pnl;
      }
    });

    return {
      filteredTradeData: filtered,
      totalPnl: calculatedTotalPnl,
      unrealizedPnl: calculatedUnrealizedPnl,
    };
  }, [tradeHistoryData, debouncedSearchTerm, strategy, prices, quantityM]); // ✅ prices dependency

  const getCompanydata = async () => {
    try {
      const res = await SET_THEME_DETAILS();
      if (res.status) {
        setBtnstatus(res.data[0]?.pnl_position);
      }
    } catch (error) { }
  };

  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 2;
    } else if (Math.abs(value) >= 1) {
      digits = 2;
    } else if (Math.abs(value) >= 0.01) {
      digits = 4;
    } else {
      digits = 6;
    }

    return Number(value.toFixed(digits));
  };

  const fetchTradeHistory = async () => {
    if (btnstatus == "") {
      return;
    }
    setLoading(true);
    try {
      const response = await getSubAdminPositions({
        fromDate: fromDate,
        toDate: toDate,
        strategy: strategy,
        orderType: orderType,
        entryType: entryType,
        UserName: SelectedUserName,
        page: currentPage,
        limit: limit,
        userid: isgotodashboard
          ? gotodashboard?.user_id
          : user_details?.user_id,
      });
      if (response?.status) {
        let allData = response.data || [];
        setTotalRows(response?.pagination?.totalRecords);
        setTradeHistoryData(allData);
      } else {
        setTradeHistoryData([]);
      }
    } catch (err) {
      setTradeHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const getFieldValue = (row, fieldName) => {
    return tradeUpdates[row._id]?.[fieldName] || row[fieldName] || "";
  };

  const getInputClassName = (row, fieldName) => {
    const errorKey = `${row._id}-${fieldName}`;
    return `form-control form-control-sm ${validationErrors[errorKey] ? "is-invalid" : ""
      }`;
  };

  const handleOnChange = (row, e) => {
    const { name, value } = e.target;
    if (!row._id) return;

    if (value < 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Negative values are not allowed!",
      });
      return;
    }

    setTradeUpdates((prev) => ({
      ...prev,
      [row._id]: { ...prev[row._id], [name]: value },
    }));
  };

  const handleUpdateRow = async (row) => {
    try {
      const target = tradeUpdates[row._id]?.target;
      const stoploss = tradeUpdates[row._id]?.stoploss;

      if (!target && !stoploss) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please fill at least Target or Stoploss!",
        });
        return;
      }

      const payload = {
        tradeId: row._id,
        target,
        stoploss,
      };

      const response = await updateTargetAndStoploss(payload);

      if (response?.status) {
        toast.success(
          response.message || "Target & Stoploss updated successfully ✅"
        );

        fetchTradeHistory();
        setEditableRows((prev) => ({ ...prev, [row._id]: false }));
      } else {
        toast.error(response?.message || "Update failed ❌");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong ❌");
    }
  };

  const refresbtn = () => {
    setStrategy("");
    setFromDate("");
    setToDate("");
    setOrderType(0);
    setEntryType("");
    setSearchTerm("");
    setSelectedUserName("");
  };

  const handleSquareOff = async (row) => {
    if (row.extstatus !== "ACTIVE") return;

    try {
      const livePrice = prices?.[row.symbol]?.spot_price; // ✅ Context से price

      const data = `symbol:${row.symbol}|ordertype:${row.side === "BUY" ? "SELL" : "BUY"
        }|quantity:100|price:${livePrice}|strategy:${row?.strategy}|key:${row.key
        }|category:${row.category}|signalType:PANEL_SQUAREOFF|tradeid:${row._id}`;

      const response = await TRADE_EXECUTE(data);

      if (response.status) {
        toast.success(response.message);
        fetchTradeHistory();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in square off:", error);
      toast.error("Failed to square off trade");
    }
  };

  const handleChange = (date) => {
    const formatted = format(date, "yyyy-MM-dd");
    return formatted;
  };

  const columns = [
    {
      name: "No",
      selector: (row, index) => (currentPage - 1) * limit + index + 1,
      sortable: false,
      width: "70px",
    },
    {
      name: "Signals Entry Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Signals Exit Time",
      selector: (row) => row.exitTime,
      cell: (row) => <>{row.exitTime ? fDateTimeSuffix(row.exitTime) : "-"}</>,
      sortable: true,
      width: "170px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      width: "120px",
    },
    {
      name: "Entry Type",
      selector: (row) => row.side,
      cell: (row) =>
        row?.side === "BUY" ? (
          <span className="badge bg-success" style={{ fontSize: "0.9rem" }}>
            BUY ENTRY
          </span>
        ) : (
          <span className="badge bg-danger" style={{ fontSize: "0.9rem" }}>
            SELL ENTRY
          </span>
        ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Quantity",
      selector: (row) => (row.quantity !== null ? quantityM : "-"),
      sortable: true,
      width: "115px",
    },
    {
      name: "Entry Price",
      selector: (row) =>
        row.entryPrice !== null ? parseFloat(row.entryPrice) : "-",
      sortable: true,
      width: "120px",
      cell: (row) =>
        row.entryPrice !== null ? roundSmart(row.entryPrice) : "-",
    },
    {
      name: "Exit / Live Price",
      selector: (row) => {
        const isOpen = row.orderid?.length === 1;
        const price = isOpen
          ? prices?.[row.symbol]?.spot_price
          : row.exitPrice;
        return price ?? 0;
      },
      cell: (row) => {
        const isOpen = row.orderid?.length === 1;
        const price = isOpen
          ? prices?.[row.symbol]?.spot_price
          : row.exitPrice;

        if (price === undefined || price === null || isNaN(price)) {
          return (
            <div
              className="spinner-border spinner-border-sm text-success"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          );
        }

        return <span>{roundSmart(price)}</span>;
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "P/L",
      selector: (row) => {
        const livePrice = prices?.[row.symbol]?.spot_price;
        return roundSmart(calculatePnL(row, livePrice));
      },
      cell: (row) => {
        const livePrice = prices?.[row.symbol]?.spot_price;
        const pnl = calculatePnL(row, livePrice);

        if (pnl === 0 && !parseFloat(row.entryPrice))
          return <span style={{ color: "gray" }}>-</span>;

        const pnlColor = pnl >= 0 ? "green" : "red";
        return <span style={{ color: pnlColor }}>{roundSmart(pnl)}</span>;
      },
      sortable: true,
      width: "100px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "140px",
    },
    {
      name: "User Name",
      selector: (row) =>
        row.userInfo?.UserName ? row.userInfo?.UserName : "Admin",
      sortable: true,
      width: "150px",
      cell: (row) => <>{row.userInfo?.UserName}</>,
    },
    {
      name: "platform",
      selector: (row) => (row.platform ? row.platform : "PANEL"),
      sortable: true,
      width: "150px",
      cell: (row) => <>{row.platform}</>,
    },
    {
      name: "Details View",
      cell: (row) => (
        <Eye
          className="mx-2"
          onClick={() => {
            setRowData(row);
            setshowModal(true);
          }}
          style={{ cursor: "pointer" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },
  ];

  return (
    <Content
      Page_title="Trade History"
      button_status={false}
      button_status1={true}
    >
      <div className="filter-row row gx-2 gy-2 align-items-end mb-3">
        {/* 🔍 Search with Debounce */}
        <div className="col-lg-2 col-md-4 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Search</label>
          <input
            type="text"
            placeholder="Search by Symbol"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
          />
        </div>

        {/* 👤 Username */}
        <div className="col-lg-2 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">User Name</label>
          <select
            value={SelectedUserName}
            onChange={(e) => setSelectedUserName(e.target.value)}
            className="form-control"
          >
            <option value="">All</option>
            <option value="ADMIN">Admin</option>

            {AllUsername?.map((data, index) => (
              <option key={index} value={data.UserName}>
                {data.UserName}
              </option>
            ))}
          </select>
        </div>

        {/* 📅 From Date */}
        <div className="col-lg-2 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">From Date</label>
          <DatePicker
            selected={fromDate ? new Date(fromDate) : null}
            onChange={(date) => {
              const formattedDate = handleChange(date);
              setFromDate(formattedDate);

            
              if (toDate && new Date(toDate) < new Date(formattedDate)) {
                setToDate(null);
              }
            }}
            dateFormat="yyyy-MM-dd"
            placeholderText="From"
            className="form-control"
            maxDate={new Date()}
          />
        </div>

        {/* 📅 To Date */}
        <div className="col-lg-2 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">To Date</label>
          <DatePicker
            selected={toDate ? new Date(toDate) : null}
            onChange={(date) => setToDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="To"
            className="form-control"
            minDate={fromDate ? new Date(fromDate) : null}
            maxDate={new Date()}
            disabled={!fromDate}
          />
        </div>


        {/* 📈 Strategy */}
        <div className="col-lg-1 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Strategy</label>
          <select
            value={strategy}
            onChange={(e) => setStrategy(e.target.value)}
            className="form-control"
          >
            <option value="">All</option>
            {allStrategy?.map((strategyOption, index) => (
              <option key={index} value={strategyOption.strategy_name}>
                {strategyOption.strategy_name}
              </option>
            ))}
          </select>
        </div>

        {/* 🧾 Order Type */}
        <div className="col-lg-1 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Order</label>
          <select
            className="form-control"
            value={orderType}
            onChange={(e) => setOrderType(e.target.value)}
          >
            <option value="">All </option>
            <option value="1">OPEN</option>
            <option value="2">CLOSED</option>
          </select>
        </div>

        {/* 🧭 Entry  */}
        <div className="col-lg-1 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Entry </label>
          <select
            className="form-control"
            value={entryType}
            onChange={(e) => setEntryType(e.target.value)}
          >
            <option value="">All </option>
            <option value="BUY">Buy</option>
            <option value="SELL">Sell</option>
          </select>
        </div>

        {/* 🔢 Quantity */}
        <div className="col-lg-1 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">Quantity</label>
          <input
            type="number"
            className="form-control"
            value={quantityM}
            onChange={(e) => {
              const val = e.target.value;
              setQuantity(val === "" ? "" : Number(val));
            }}
          />
        </div>

        {/* 🔁 Refresh Button */}
        <div className="col-lg-1 col-md-2 col-sm-3 d-flex justify-content-end">
          <button
            className="btn btn-sm btn-primary mt-auto w-100"
            onClick={() => {
              setRefresh((prev) => !prev);
              refresbtn();
            }}
          >
            <i className="fa fa-refresh"></i>
          </button>
        </div>
      </div>
      {btnstatus === "0" && (
        <div
          className="mt-3 d-flex flex-wrap justify-content-start align-items-center gap-4"
          style={{
            borderTop: "1px solid #ddd",
            paddingTop: "10px",
            marginBottom: "10px",
            borderRadius: "8px",
            padding: "10px 15px",
          }}
        >
          <div>
            <h6 className="mb-1 fw-semibold" style={{ fontSize: "14px" }}>
              Realized P&L
            </h6>
            <span
              style={{
                color: Number(totalPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              {"$"} {Number(roundSmart(totalPnl || 0))}
            </span>
          </div>

          <div>
            <h6 className="mb-1 fw-semibold" style={{ fontSize: "14px" }}>
              UnRealized P&L
            </h6>
            <span
              style={{
                color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              {"$"} {Number(roundSmart(unrealizedPnl || 0))}
            </span>
          </div>
        </div>
      )}

      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <Table
            columns={columns}
            data={filteredTradeData}
            waterMark={true}
            totalRows={totalRows}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handlePerRowsChange}
            limit={limit}
          />

          {btnstatus == "1" && (
            <div className="mt-3 d-flex justify-content-end">
              <h5>
                Realized P&L:{" "}
                <span style={{ color: totalPnl >= 0 ? "green" : "red" }}>
                  {"$"} {Number(roundSmart(totalPnl || 0))}
                </span>
              </h5>
              <h5 className="ms-4">
                UnRealized P&L:{" "}
                <span
                  style={{
                    color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                  }}
                >
                  {"$"} {Number(roundSmart(unrealizedPnl || 0))}
                </span>
              </h5>
            </div>
          )}
        </div>
      )}

      <DetailsView
        showModal={showModal}
        setshowModal={() => setshowModal(false)}
        tradeHistoryData={rowData}
      />
    </Content>
  );
};

export default Tradinghistory;